<template>
	<div>
		<list-page-gen :options="options" />
	</div>
</template>

<script>
import ListPageGen from './ListPageGen.vue'

const config = {
	options: {
		resource: 'summary-status-actions',
		comparisonDisplay: ['id', 'clientId', 'availableFor'],
		postThenPatch: true,
		modifier: async data =>
			data.map(r => {
				r.summaryItemActions = r.summaryItemActions.map(i => i.id)
				return r
			}),
		filterModifier: async data => {
			data.autocompleteFields = [
				{
					name: 'clientId.clientId',
					resource: 'clients',
					query: 'id',
					display: 'id'
				}
			]
			return data
		}
	}
}

export default {
	name: 'SummaryStatusActionsList',
	components: { ListPageGen },
	data: () => config
}
</script>
